import { render, staticRenderFns } from "./nuevaLista.vue?vue&type=template&id=ce57f822&scoped=true&lang=html&"
import script from "./nuevaLista.vue?vue&type=script&lang=js&"
export * from "./nuevaLista.vue?vue&type=script&lang=js&"
import style0 from "./nuevaLista.vue?vue&type=style&index=0&id=ce57f822&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce57f822",
  null
  
)

export default component.exports